import { PlusCircle } from "react-feather";
import DataTable from "../Generic/DataTable";
import React, { useContext, useEffect, useRef, useState } from "react";
import { tenantContext } from "../Main/contexts";
import {
    CreateUser,
    DeleteUser,
    GetMembership,
    GetUser,
    GetUserResponse,
    GetUsers,
    MailboxMembership,
    UpdateMembership,
    UpdateUser,
    UserMailboxMembership,
    UsersGridListDTO,
    UsersListDTO,
} from "./TenantAPI";
import Loading from "../Generic/loading";
import { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import TextBox from "../Generic/TextBox";
import NumberBox from "../Generic/NumberBox";
import ToggleSwitch from "../Generic/ToggleSwitch";
import TextArea from "../Generic/TextArea";
import Dropdown from "../Generic/DropDown";
import { Departments, GetDepartmentResponse } from "../Logic/department";
import { GetGlobalRoles, GetMailboxRoles, GlobalRolesListItemDTO, MailboxRolesListItemDTO } from "../Roles/TenantAPI";
import { GetMailboxes, MailboxList } from "../Mailboxes/TenantAPI";

function Memberships() {
    const { selectedTenant } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [allUsers, setAllUsers] = useState<Array<UsersListDTO>>([]);
    const [filtertedGridaData, setFiltertedGridaData] = useState<Array<UsersGridListDTO>>([]);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState("");
    const [selectedUserMembership, setSelectedUserMembership] = useState<UserMailboxMembership | undefined>(undefined);
    const [mailboxes, setMailboxes] = useState<Array<MailboxList>>([]);
    const [mailboxesFiltered, setMailboxesFiltered] = useState<Array<MailboxList>>([]);
    const [mailboxRoles, setMailboxroles] = useState<Array<MailboxRolesListItemDTO>>([]);
    const [isNewUser, setIsNewUser] = useState<Boolean>(true);
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);

    const mMailboxFilterT = useRef<HTMLInputElement>(null);
    const mMailboxCheckboxFilterT = useRef(null);

    useEffect(() => {
        (async () => {
            if (selectedTenant) {
                const user_results = GetUsers(selectedTenant.token);
                const mailboxes_results = GetMailboxes(selectedTenant.token);
                const mailboxRoles_results = GetMailboxRoles(selectedTenant.token);
                Promise.all([user_results, mailboxes_results, mailboxRoles_results]).then(results => {
                    if (results[0].isOk) {
                        setAllUsers(results[0].data?.users!);
                        let filtertedList = results[0].data!.users!.map(user => {
                            return {
                                id: user.id,
                                userName: user.firstname + " " + user.lastname,
                                blocked: user.blocked,
                                globalRole: user.globalRole,
                                department: user.department,
                            };
                        });
                        setFiltertedGridaData(filtertedList);
                    }
                    if (results[1].isOk) {
                        setMailboxes(results[1].data?.items!);
                        setMailboxesFiltered(results[1].data?.items!);
                    }
                    if (results[2].isOk) {
                        setMailboxroles(results[2].data?.items!);
                    }
                    setIsLoading(false);
                });
            }
        })();
    }, [selectedTenant]);

    let AllColumns: dataColumn<UsersGridListDTO>[] = [
        {
            title: <>User Name</>,
            toolTip: "name",
            key: "username",
            getData: (data: UsersGridListDTO) => {
                return <>{data.userName}</>;
            },
            width: "50%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("userName");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
        {
            title: <>Role</>,
            toolTip: "role",
            key: "role",
            getData: (data: UsersGridListDTO) => {
                return <>{data.globalRole}</>;
            },
            width: "10%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("globalRole");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
        {
            title: <>Department</>,
            toolTip: "department",
            key: "department",
            getData: (data: UsersGridListDTO) => {
                return <>{data.department}</>;
            },
            width: "40%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("department");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(filtertedGridaData, fieldName, sortO.desc);
        setFiltertedGridaData(updatedGrids);
        setSortBy(sortO);
    };

    function OnFilter(filterValue: string) {
        let filtertedList = allUsers.map(user => {
            return {
                id: user.id,
                userName: user.firstname + " " + user.lastname,
                blocked: user.blocked,
                globalRole: user.globalRole,
                department: user.department,
            };
        });
        let filtered = filtertedList.filter(
            x =>
                x.userName?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0 ||
                x.department?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0 ||
                x.globalRole?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0,
        );
        setFiltertedGridaData(filtered);
    }

    function MailBoxOnFilterT(filterValue: string) {
        let filtertedList = mailboxes;
        let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
        setMailboxesFiltered(filtered);
    }

    const filteredCheckbox = (checked: boolean) => {
        let filtered = mailboxes.filter(x =>
            x.name.toLowerCase().includes(mMailboxFilterT.current!.value.toLowerCase()),
        );
        if (checked) {
            filtered = filtered.filter(
                x => x.id == selectedUserMembership?.mailboxes.find(c => c.mailboxID == x.id)?.mailboxID,
            );
            setMailboxesFiltered(filtered);
        } else {
            setMailboxesFiltered(filtered);
        }
    };

    async function getUserInfo(id: string) {
        if (selectedTenant) {
            setSelectedItem(id);
            const result = await GetMembership(selectedTenant.token, parseInt(id));
            if (result.isOk && result.data) {
                setSelectedUserMembership({ userId: parseInt(id), mailboxes: result.data.items });
                setIsNewUser(false);
            }
        }
    }
    const isUserBlocked = (item: UsersGridListDTO): string => {
        return item.blocked ? " blocked " : "";
    };
    const updateValue = (field: string, value: any) => {
        if (value == "undefined" || value == "null") return;
        let uUser: UserMailboxMembership = JSON.parse(JSON.stringify(selectedUserMembership));

        if (uUser.mailboxes.find(x => x.mailboxID.toString() == field)) {
            if (value == "0") {
                // Means no access
                uUser.mailboxes = uUser.mailboxes.filter(x => x.mailboxID.toString() != field);
            } else {
                uUser.mailboxes.find(x => x.mailboxID.toString() == field)!.roleID = value;
            }
        } else {
            if (value !== "0") {
                uUser.mailboxes.push({ mailboxID: parseInt(field), roleID: value });
            }
        }
        setSelectedUserMembership(uUser);
    };

    const updateUserMembership = async () => {
        if (isValidUser()) {
            if (selectedTenant && selectedUserMembership) {
                const result = await UpdateMembership(
                    selectedTenant.token,
                    selectedUserMembership.userId,
                    selectedUserMembership,
                );
                if (result.isOk) {
                    alert("user Updated");
                }
            }
        }
    };

    const isValidUser = (): boolean => {
        if (
            selectedUserMembership &&
            selectedUserMembership.mailboxes.find(x => x.roleID == undefined || x.roleID == null)
        ) {
            alert("Please select a value for the highlighted field");
            return false;
        }
        return true;
    };

    return (
        <>
            <div className="topSection">
                <div className="sectionHeader"> Users - Memberships</div>
                {selectedUserMembership && !isNewUser && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateUserMembership}
                        >
                            {" "}
                            Update Membership{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 44px)" }}>
                <div
                    className="Users-bodyCol1"
                    style={{ flex: "0 0 500px" }}
                >
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={filtertedGridaData.slice().sort((a, b) => {
                                    if (a.blocked !== b.blocked) return a.blocked ? 1 : -1;
                                    return (a.userName ?? "").localeCompare(b.userName ?? "");
                                })}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getUserInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                                getCustomClass={isUserBlocked}
                            ></DataTable>
                        </>
                    )}
                </div>
                {selectedUserMembership && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                Mailbox Memberships{" "}
                            </p>
                        </div>
                        <div className="filterMailboxContainer">
                            <div>Filter: </div>
                            <div>
                                <input
                                    type="text"
                                    style={{ width: "100%" }}
                                    onChange={e => MailBoxOnFilterT(e.currentTarget.value)}
                                    ref={mMailboxFilterT}
                                />
                            </div>
                        </div>
                        <div className="filterMailboxContainer">
                            <div>Filter by Access: </div>
                            <div>
                                <input
                                    type="checkbox"
                                    key={"MailIdds"}
                                    onChange={e => filteredCheckbox(e.currentTarget.checked)}
                                    value={""}
                                    ref={mMailboxCheckboxFilterT}
                                />
                            </div>
                        </div>
                        {mailboxesFiltered.map((c, i) => {
                            const membershipM = selectedUserMembership.mailboxes.find(x => x.mailboxID == c.id);
                            let options: [{ label: string; value: string }] = [{ label: " No Access", value: "0" }];
                            if (membershipM && (membershipM.roleID == undefined || membershipM.roleID == null)) {
                                options.push({ label: " No Access", value: "0" });
                            }
                            return (
                                <div className="formRow">
                                    <Dropdown
                                        name={c.id.toString()}
                                        label={c.name}
                                        value={
                                            membershipM
                                                ? membershipM.roleID == undefined
                                                    ? ""
                                                    : membershipM.roleID.toString()
                                                : "0"
                                        }
                                        returnFunc={updateValue}
                                        Valid={
                                            membershipM &&
                                            (membershipM.roleID == undefined || membershipM.roleID == null)
                                                ? false
                                                : true
                                        }
                                        options={options.concat(
                                            mailboxRoles.map(items => {
                                                return { label: items.name, value: items.id.toString() };
                                            }),
                                        )}
                                    ></Dropdown>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
}
export default Memberships;
